import TableBody from '@mui/material/TableBody';
import type { FC, ReactNode } from 'react';

interface TableBodyProps {
    id: string;
    children?: ReactNode;
    className?: string;
}

const CustomTableBody: FC<TableBodyProps> = ({
  id,
  children,
  className,
  ...rest
}) => {

  return (
    <TableBody
      id={id}
      className= {className}
      {...rest}
    >
      {children}
    </TableBody>
  );
}

export default CustomTableBody